import { Injectable } from '@angular/core';
import { GlobalComponent } from '../../global-component';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { TokenStorageService } from './token-storage.service';
import { User } from '../models/user.models';
const BASE_URL = GlobalComponent.BASE_API_URL;
const AUTH_API = BASE_URL + GlobalComponent.AUTH_API;
@Injectable({
  providedIn: 'root'
})
export class DashboardService {
  currentuser: User;
  constructor(private http: HttpClient, private tokenService: TokenStorageService) {
    this.currentuser = this.tokenService.getUser();
  }

  /**
   * VENDOR DASHBOARD API'S
   */
  getUsersInfo(): Observable<any> {
    console.log('test api call again ---');
    return this.http.get<any>(BASE_URL + `vendor/dashboard/vendorstats?vendorguid=`+this.tokenService.getVendorGUID()!);
  }


  getRevenueInfo(postdata: any): Observable<any> {
    return this.http.get<any>(BASE_URL + `vendor/dashboard/revenuestats?startdate=`+postdata.startdate+'&enddate='+postdata.enddate+'&vendorguid='+postdata.vendorguid);
  }

  getOrdersOverview(postdata: any): Observable<any> {
    return this.http.get<any>(BASE_URL + `vendor/dashboard/ordersstats?startdate=`+postdata.startdate+'&enddate='+postdata.enddate+'&vendorguid='+postdata.vendorguid);
  }

  /**
   * CLIENT DASHBOARD API'S
   */
  getClientStats(): Observable<any> {
    return this.http.get<any>(BASE_URL + `client/dashboard/clientstats`);
  }

  getClientOrdersOverview(postdata: any): Observable<any> {
    return this.http.get<any>(BASE_URL + `client/dashboard/ordersstats?startdate=`+postdata.startdate+'&enddate='+postdata.enddate);
  }

  getClientActiveOrderInfo() : Observable<any> {
    return this.http.get<any>(BASE_URL + `client/dashboard/activeorders`);
  }

  /**
   * STAMPING PARTNER DASHBOARD API'S
   */
  getStampingPartnerRevenueInfo(postdata: any): Observable<any> {
    return this.http.get<any>(BASE_URL + `stampingpartner/dashboard/revenuestats?startdate=`+postdata.startdate+'&enddate='+postdata.enddate+'&vendorguid='+postdata.vendorguid);
  }

  getStampingPartnerOrdersOverview(postdata: any): Observable<any> {
    return this.http.get<any>(BASE_URL + `stampingpartner/dashboard/ordersstats?startdate=`+postdata.startdate+'&enddate='+postdata.enddate+'&vendorguid='+postdata.vendorguid);
  }

  getStampingPartnerStats(): Observable<any> {
    return this.http.get<any>(BASE_URL + `stampingpartner/dashboard/stampingpartnerstats?vendorguid=`+this.tokenService.getVendorGUID()!);
  }
  
  // Get performance of the team member - Vendor
  getMemberStatsVendor (page:number , pageSize:number ): Observable<any> {
    return this.http.get<any>(`${BASE_URL}vendor/dashboard/v1a/memberstats?vendorguid=`+this.tokenService.getVendorGUID()! + `&pageSize=`+pageSize + `&page=`+page);
  }

    // // Get performance of the team member - Client
    // getMemberStatsClient(): Observable<any> {
    //   return this.http.get<any>(`${BASE_URL}client/dashboard/v1a/memberstats?clientguid=`+this.currentuser.guid);
    // }
       // Get performance of the team member - Client
    getMemberStatsClient(page : number , pageSize : number): Observable<any> {
      return this.http.get<any>(`${BASE_URL}client/dashboard/v1a/memberstats?clientguid=` + this.currentuser.guid + `&vendorguid=` + this.tokenService.getVendorGUID()! + `&pageSize=`+pageSize + `&page=`+page);
    }

  
    

}